import arrangement from '../assets/arrangement.jpg';  
import binamuda from '../assets/binamuda.jpg'; 

export default function Projects() {
  return (
  <div className="container">   
    <div className="page">
  
    <h2 className='align_center'>      
      Projects
    </h2>
    
    <div className="align_left" >

      We currently have projects underway in South America and Indonesia.<br />
      Our projects are focused on reducing dependence on fossil fuels from coal-fired power plants and diesel generators.<br />
      In Indonesia, in cooperation with &nbsp;
      
        <a href='https://www.binamudateknikatama.com/'  target="_blank" rel="noreferrer" >
          PT Bina Muda Teknikatama
        </a>.        
      
      
      <br />

        <a href='https://www.binamudateknikatama.com/' target="_blank" rel="noreferrer" style={{textDecoration: 'none', marginLeft: '70px'}}>
          <div class="container">        
              <img src={binamuda} style={{width: '300px', objectFit: 'fill', marginRight: '10px' }} alt=''/>	       
          </div>
        </a>
      <br />
      We are planning to replace over 500 MW of coal-generated power, while our South American project will revolutionise the aquaculture industry by replacing tens of megawatt-hours of diesel-generated power with clean, reliable renewable energy.<br />
      To increase power output, we have proposed combining wave energy with other renewable energy sources.<br />
      For our Indonesian project, we are combining wave energy with solar power.<br />

      <br />
    </div>     
   
    <div class="container">        
        <img src={arrangement} style={{width: '900px', objectFit: 'fill', marginRight: '10px' }} alt=''/>	       
    </div>


  </div>
  </div>
)}
